<script setup>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import _ from "lodash";
import moment from "moment";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import jobFairUserService from "../../../../user/services/jobFair/jobFairUserService";
import adminJobfairService from "../../../services/jobfair/adminJobfairService";
import adminApprovedJoinStateService from "../../../services/jobfair/adminApprovedJoinStateService";
import SNBAdmin from "../../../../../layouts/nav/SNBAdmin.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import JobFairJobNoticeModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeModal.vue";
import KSATextButton from "@/components/ui-components/button/KSATextButton.vue";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import JobFairResumeModal from "@/pages/user/components/modal/jobFair/JobFairResumeModal.vue";
import RecruitmentHallCorpModal from "@/pages/admin/components/modal/jobFair/RecruitmentHallCorpModal.vue";
import RecruitmentHallModal from "@/pages/admin/components/modal/jobFair/RecruitmentHallModal.vue";
import JobFairResumeOpenModal from "@/pages/user/components/modal/jobFair/JobFairResumeOpenModal.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
const { $alert, $confirm } = useAlertStore();

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore();
const { $pageListBoardNo, $toast, $number, $gbNameKR, $yyyymmddHHmmss, $interests, $intvGb, $applyStateGb, $userIntvStateGb, $adminIntvStateGb } = getCurrentInstance().appContext.config.globalProperties;

const ojfId = ref(0);
const ojfGb = ref(route.query.ojfGb || '');

const BASIC = 'BASIC';
const RETRIEVE_APPLICANT = 'RETRIEVE_APPLICANT'; // 재직자/기업 : 채용공고 - 입사지원
const RETRIEVE_APPLICANT2 = 'RETRIEVE_APPLICANT2'; // 학생/취업준비생 : 이력서 - 입사지원

const detailCommonId = ref('');     // jobNoticeSeq, resumeId
const detailCommonData = ref('');   // corpId, fileYn
const detailCommonData2 = ref('');  // fileYn

// 재직자/기업 : 채용공고
const viewMode = ref(BASIC); // JOB_NOTICE
// 탭 상세 화면 보기 조건
const setViewMode = (viewName, commonId, commonData, fileYn) => {
    // 공통 사용변수 초기화
    currentPage.value = 1;
    pageSize.value = 10;

    // depth2에서 사용할 데이터 들
    detailCommonId.value = commonId; // jobNoticeSeq, resumeId
    detailCommonData.value = commonData; // corpId, fileYn
    detailCommonData2.value = fileYn; // fileYn

    if(viewName === BASIC) {
        retrieveList();
    } else if(viewName === RETRIEVE_APPLICANT) { // 재직자/기업 : 채용공고 - 입사지원
        retrieveOjfResumeListByByJobNoticeSeqAdminPaging(commonId); // commonId : jobNoticeSeq
    } else if(viewName === RETRIEVE_APPLICANT2) { // 학생/취업준비생 : 이력서 - 입사지원
        retrieveApplicantListByResumeIdPaging(commonId); // commonId : resumeId
    }
    viewMode.value = viewName;
}

// 상단 tab 옆 (count)
const totalCnt11 = ref(0);
const totalCnt12 = ref(0);
const totalCnt13 = ref(0);
const totalCnt14 = ref(0);
const totalCnt21 = ref(0);
const totalCnt22 = ref(0);
const totalCnt23 = ref(0);
const totalCnt24 = ref(0);

const data_interests = ref($interests); // 관심 카테고리
const data_intvGb = ref($intvGb); // 면접방식
const data_applyStateGb = ref($applyStateGb); // 서류지원상태
const data_userIntvStateGb = ref($userIntvStateGb); // 사용자면접제안상태
const data_adminIntvStateGb = ref($adminIntvStateGb); // 관리자면접제안상태

const ojfIntvDayList = ref([]);  // 면접 가능일 전체 리스트 for 체크박스 생성용
const ojfIntvDays = ref([]);     // 면접 가능일 전체 리스트 for 초기화 용

const ojfDetail = ref({});    // 행사 정보(for 행사명)
const corpList11 = ref([]);   // 재직자/기업(1) - 참가기업(1) 리스트
const corpList12 = ref([]);   // 재직자/기업(1) - 채용공고(2) 리스트
const corpList13 = ref([]);   // 재직자/기업(1) - 입사지원(3) 리스트
const corpList14 = ref([]);   // 재직자/기업(1) - 면접제안 인재(4) 리스트
const stuList21 = ref([]);    // 학생/취업준비생(2) - 참가회원(1) 리스트
const stuList22 = ref([]);    // 학생/취업준비생(2) - 이력서(2) 리스트
const stuList23 = ref([]);    // 학생/취업준비생(2) - 입사지원(3) 리스트
const stuList24 = ref([]);    // 학생/취업준비생(2) - 받은 면접제안(4) 리스트

const applicantList = ref([]); // 재직자/기업(1) - 채용공고(2) - 입사지원 리스트
const applicantList2 = ref([]); // 학생/취업준비생(2) - 이력서(2) - 입사지원 리스트

// 초기화 버튼 처리를 위한 ref 지정
const searchTypeRef = ref(null);
const interestsListRef = ref(null);
const intvsListRef = ref(null);
const intvDaysListRef = ref(null);
const applyStateGbsListRef = ref(null);
const intvPropStateGbsListRef = ref(null);
const adminIntvPropStateGbsListRef = ref(null);

onMounted( async () => {
    const { id } = route.params;
    if (!id) {
        goBack();
    } else {
        ojfId.value = id;

        await ojfIntvDay();                            // 행사 면접 가능일 조회
        retrieveOnlineJobFair();                       // 행사 정보 조회(for 행사명)
        retrieveApprovedCorpCountByOjfId();            // 재직자/기업 tab옆 count
        retrieveApprovedStuCountByOjfId();             // 학생/취업준비생 tab옆 count
        retrieveApprovedRecruitmentHallPaging();       // 재직자/기업(1) - 참가기업(1) 리스트
    }
});

// tabIndex
const tabOptions = ref([
    {label: '재직자/기업', value: 1},
    {label: '학생/취업준비생', value: 2},
])

// 검색 초기값 설정
const searchInput11 = ref({ // 재직자/기업(1) - 참가기업(1)
    searchType: 'corpName', // corpName 기업명, userName 이름, id 아이디, code 회원코드
    searchInput: '',
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchApprovedDurationType: 'all',
    startApprovedYmd: '',
    endApprovedYmd: '',
    joinStateGbsList: ['11'],
});
const searchInput12 = ref({ // 재직자/기업(1) - 채용공고(2)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchIntvGbs: ['01', '02', '03', '04'],
    searchIntvInYn: 'A',
    searchIntvAbleDay: [],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'corpName', // corpName 기업명, title 채용공고제목, name 등록마스터
    searchInput: '',
});
const searchInput13 = ref({ // 재직자/기업(1) - 입사지원(3)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchIntvInYn: 'A',
    searchIntvAbleDay: [],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'name', // name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명
    searchInput: '',
});

const searchInput14 = ref({ // 재직자/기업(1) - 면접제안 인재(4)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchIntvPropStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchIntvInYn: 'A',
    searchIntvAbleDay: [],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'name', // name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명
    searchInput: '',
});

const searchInput21 = ref({ // 학생/취업준비생(2) - 참가회원(1)
    searchType: 'userName', // userName 이름, id 아이디, code 회원코드
    searchInput: '',
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchApprovedDurationType: 'all',
    startApprovedYmd: '',
    endApprovedYmd: '',
    joinStateGbsList: ['11'],
});
const searchInput22 = ref({ // 학생/취업준비생(2) - 이력서(2)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchIntvInYn: 'A',
    searchIntvAbleDay: [],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'name', // name 이름, id 아이디, rTitle 이력서 제목
    searchInput: '',
});
const searchInput23 = ref({ // 학생/취업준비생(2) - 입사지원(3)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchIntvInYn: 'A',
    searchIntvAbleDay: [],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'applicantName', // applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목
    searchInput: '',
});
const searchInput24 = ref({ // 학생/취업준비생(2) - 받은 면접제안(4)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchIntvPropStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchIntvInYn: 'A',
    searchIntvAbleDay: [],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'applicantName', // applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목
    searchInput: '',
});

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);
const searchOpen = ref(true);

const tabIndex = ref(1);
const tabIndex2 = ref(1);

const jobNoticeModal = ref(null); // 채용공고
const jobFairResumeModal = ref(null); // 이력서
const recruitmentHallCorpModal = ref(null); // 신청정보 - 재직자/기업
const recruitmentHallModal = ref(null); // 신청정보 - 학생/취업준비생
const jobFairResumeOpenModal = ref(null); // 인재정보 공개

// 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색)
const searchDurationTypeGroup = ref([
    { label:'모든 기간', value: 'all' },
    { label:'기간 검색', value: 'term' },
])
// 날짜 검색이 2개인 경우 존재하여 하나 더 생성. 승인일
const searchApprovedDurationTypeGroup = ref([
    { label:'모든 기간', value: 'all' },
    { label:'기간 검색', value: 'term' },
])

// 검색조건 - 재직자/기업 면접 가능일
const searchCorpIntvInYnGroup = ref([
  { label:'전체', value: 'A' },
  { label:'면접기간 내 일정', value: 'Y' },
  { label:'면접 일정 조율', value: 'N' },
])
// 검색조건 - 학생/취업준비생 면접 가능일
const searchStuIntvInYnGroup = ref([
  { label:'전체', value: 'A' },
  { label:'면접기간 내 일정', value: 'Y' },
  { label:'면접 일정 조율', value: 'N' },
])

// 검색조건 - 페이지 크기
const pageSizeGroup = ref([
    { label:'10개씩 보기', value: '10' },
    { label:'30개씩 보기', value: '30' },
    { label:'50개씩 보기', value: '50' },
    { label:'100개씩 보기', value: '100' },
])

// text 검색. tab 마다 항목 다름.
const searchTypeGroup11 = ref([
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
    { label:"이름", value: "userName", placeholder: "이름을 입력해주세요." },
    { label:'아이디', value: 'id', placeholder: "아이디를 입력해주세요." },
    { label:"회원코드", value: "code", placeholder: "회원코드를 입력해주세요."  },
]);
const searchInputPlaceholder11 = computed(()=>{
    const option = _.find(searchTypeGroup11.value, { value: searchInput11.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchTypeGroup12 = ref([
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
    { label:"채용공고 제목", value: "title", placeholder: "채용공고 제목을 입력해주세요." },
    { label:'등록 마스터', value: 'name', placeholder: "등록 마스터 이름을 입력해주세요." },
]);
const searchInputPlaceholder12 = computed(()=>{
    const option = _.find(searchTypeGroup12.value, { value: searchInput12.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchTypeGroup13 = ref([
    { label:"이름", value: "name", placeholder: "이름을 입력해주세요."  },
    { label:"아이디", value: "id", placeholder: "아이디를 입력해주세요." },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
    { label:"채용공고 제목", value: "jnTitle", placeholder: "채용공고 제목을 입력해주세요."  },
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
]);
const searchInputPlaceholder13 = computed(()=>{
    const option = _.find(searchTypeGroup13.value, { value: searchInput13.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchTypeGroup14 = ref([
    { label:"이름", value: "name", placeholder: "이름을 입력해주세요."  },
    { label:"아이디", value: "id", placeholder: "아이디를 입력해주세요." },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
    { label:"채용공고 제목", value: "jnTitle", placeholder: "채용공고 제목을 입력해주세요."  },
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
]);
const searchInputPlaceholder14 = computed(()=>{
    const option = _.find(searchTypeGroup14.value, { value: searchInput14.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchTypeGroup21 = ref([
    { label:"이름", value: "userName", placeholder: "이름을 입력해주세요." },
    { label:'아이디', value: 'id', placeholder: "아이디를 입력해주세요." },
    { label:"회원코드", value: "code", placeholder: "회원코드를 입력해주세요."  },
]);
const searchInputPlaceholder21 = computed(()=>{
    const option = _.find(searchTypeGroup21.value, { value: searchInput21.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchTypeGroup22 = ref([
    { label:"이름", value: "name", placeholder: "이름을 입력해주세요."  },
    { label:"아이디", value: "id", placeholder: "아이디를 입력해주세요." },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
]);
const searchInputPlaceholder22 = computed(()=>{
    const option = _.find(searchTypeGroup22.value, { value: searchInput22.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchTypeGroup23 = ref([
    { label:"이름", value: "applicantName", placeholder: "이름을 입력해주세요."  },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
    { label:"마스터 이름", value: "name", placeholder: "마스터 이름을 입력해주세요."  },
    { label:"채용공고 제목", value: "jTitle", placeholder: "채용공고 제목을 입력해주세요."  },
]);
const searchInputPlaceholder23 = computed(()=>{
    const option = _.find(searchTypeGroup23.value, { value: searchInput23.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

const searchTypeGroup24 = ref([
    { label:"이름", value: "applicantName", placeholder: "이름을 입력해주세요."  },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
    { label:"마스터 이름", value: "name", placeholder: "마스터 이름을 입력해주세요."  },
    { label:"채용공고 제목", value: "jTitle", placeholder: "채용공고 제목을 입력해주세요."  },
]);
const searchInputPlaceholder24 = computed(()=>{
    const option = _.find(searchTypeGroup24.value, { value: searchInput24.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

// 면접 가능일 조회. for 검색
const ojfIntvDay = async () => {
    loadingStore.loading = true;
    try {
        const res = await jobFairUserService.ojfIntvDay(ojfId.value);
        loadingStore.loading = false;

        if (res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            if (result) {
                const dayList = result.split(','); // 결과값 예: ['4.7(월)', '4.8(화)', '4.9(수)', '4.10(목)']
                ojfIntvDays.value = dayList;
                ojfIntvDayList.value = dayList.map(day => ({ label: day, value: day }));

                // 체크박스 초기값 설정
                searchInput12.value.searchIntvAbleDay = dayList;
                searchInput13.value.searchIntvAbleDay = dayList;
                searchInput22.value.searchIntvAbleDay = dayList;
                searchInput23.value.searchIntvAbleDay = dayList;
                searchInput24.value.searchIntvAbleDay = dayList;
            }
        }
    } catch (error) {
        console.error(error);
        loadingStore.loading = false;
    }
}

// 행사 정보 조회 for 상단 행사명 타이틀
const retrieveOnlineJobFair = () => {
    loadingStore.loading = true;
    adminJobfairService.retrieveOnlineJobFair(ojfId.value)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                ojfDetail.value = res.data.result;
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 재직자/기업 START
// 0. TAB 옆 count
const retrieveApprovedCorpCountByOjfId = () => {
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveApprovedCorpCountByOjfId(ojfId.value)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalCnt11.value = result.totalCnt11;
                totalCnt12.value = result.totalCnt12;
                totalCnt13.value = result.totalCnt13;
                totalCnt14.value = result.totalCnt14;
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 1. 재직자/기업(1) - 참가기업(1) 리스트
const retrieveApprovedRecruitmentHallPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchJoinStateGb: _.map(searchInput11.value.joinStateGbsList).join(','),
        searchType: searchInput11.value.searchType,
        searchInput: searchInput11.value.searchInput,
        startYmd: searchInput11.value.searchDurationType === 'all' ? '' : searchInput11.value.startYmd,
        endYmd: searchInput11.value.searchDurationType === 'all' ? '' : searchInput11.value.endYmd,
        startApprovedYmd: searchInput11.value.searchApprovedDurationType === 'all' ? '' : searchInput11.value.startApprovedYmd,
        endApprovedYmd: searchInput11.value.searchApprovedDurationType === 'all' ? '' : searchInput11.value.endApprovedYmd,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveApprovedRecruitmentHallPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                corpList11.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

// 2. 재직자/기업(1) - 채용공고(2) 리스트
const retrieveJobNoticeListPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchInterests: _.map(searchInput12.value.searchInterests).join(','),
        searchIntvGbs: _.map(searchInput12.value.searchIntvGbs).join(','),
        searchIntvInYn: searchInput12.value.searchIntvInYn,
        searchIntvAbleDay: _.map(searchInput12.value.searchIntvAbleDay).join(','),
        startYmd: searchInput12.value.searchDurationType === 'all' ? '' : searchInput12.value.startYmd,
        endYmd: searchInput12.value.searchDurationType === 'all' ? '' : searchInput12.value.endYmd,
        searchType: searchInput12.value.searchType,
        searchInput: searchInput12.value.searchInput,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveJobNoticeListPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                corpList12.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 2. 재직자/기업(1) - 채용공고(2) 리스트 - 입사지원 리스트
const retrieveOjfResumeListByByJobNoticeSeqAdminPaging = (jobNoticeSeq) => {
  let paramObj = {
    jobNoticeSeq: jobNoticeSeq,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }

  loadingStore.loading = true;
  adminApprovedJoinStateService.retrieveOjfResumeListByByJobNoticeSeqAdminPaging(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          applicantList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 3. 재직자/기업(1) - 입사지원(3) 리스트
const retrieveAllOjfResumeListAdminPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchInterests: _.map(searchInput13.value.searchInterests).join(','),
        searchApplyStateGbs: _.map(searchInput13.value.searchApplyStateGbs).join(','),
        searchIntvInYn: searchInput13.value.searchIntvInYn,
        searchIntvAbleDay: _.map(searchInput13.value.searchIntvAbleDay).join(','),
        startYmd: searchInput13.value.searchDurationType === 'all' ? '' : searchInput13.value.startYmd,
        endYmd: searchInput13.value.searchDurationType === 'all' ? '' : searchInput13.value.endYmd,
        searchType: searchInput13.value.searchType,
        searchInput: searchInput13.value.searchInput,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveAllOjfResumeListAdminPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                corpList13.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};
// 3. 재직자/기업(1) - 면접제안 인재(4) 리스트
const retrieveAllInterviewProposalEntryListByOjfIdPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchInterests: _.map(searchInput14.value.searchInterests).join(','),
        searchIntvPropStateGbs: _.map(searchInput14.value.searchIntvPropStateGbs).join(','),
        searchIntvInYn: searchInput14.value.searchIntvInYn,
        searchIntvAbleDay: _.map(searchInput14.value.searchIntvAbleDay).join(','),
        startYmd: searchInput14.value.searchDurationType === 'all' ? '' : searchInput14.value.startYmd,
        endYmd: searchInput14.value.searchDurationType === 'all' ? '' : searchInput14.value.endYmd,
        searchType: searchInput14.value.searchType,
        searchInput: searchInput14.value.searchInput,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveAllInterviewProposalEntryListByOjfIdPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                corpList14.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};
// 4. 재직자/기업 - '엑셀 다운로드' 클릭
const onClickCorpExcelDownload = async () => {
  const ok = await $confirm(["재직자/기업 참가신청 목록을 내 PC로 다운로드할까요?"], "다운로드");
  if(ok){
    retrieveApprovedRecruitmentHallStatusExcel();
  }
}

// 4-1. 재직자/기업 - 엑셀 다운로드
const retrieveApprovedRecruitmentHallStatusExcel = () => {
  let paramObj = {
    ojfId: ojfId.value,
    pageSource: 'approved',
    searchJoinStateGb: _.map(searchInput11.value.joinStateGbsList).join(','),
    searchType: searchInput11.value.searchType,
    searchInput: searchInput11.value.searchInput,
    startYmd: searchInput11.value.searchDurationType === 'all' ? '' : searchInput11.value.startYmd,
    endYmd: searchInput11.value.searchDurationType === 'all' ? '' : searchInput11.value.endYmd,
    startApprovedYmd: searchInput11.value.searchApprovedDurationType === 'all' ? '' : searchInput11.value.startApprovedYmd,
    endApprovedYmd: searchInput11.value.searchApprovedDurationType === 'all' ? '' : searchInput11.value.endApprovedYmd,
  }
  $toast('', `다운로드 데이터 생성을 시작합니다.`);
  loadingStore.loading = true;
  adminApprovedJoinStateService.retrieveApprovedRecruitmentHallStatusExcel(paramObj)
    .then( async (res) => {
      loadingStore.loading = false;
      try {
        const href = URL.createObjectURL(res.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `${ ojfDetail.value.ojfName }_${moment().format("YYYYMMDD")}_재직자/기업 참가신청 리스트.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      } catch(e) {
        console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
      }
    }).catch((err) => {
    loadingStore.loading = false;
    let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
    // Blob 응답 처리
    err.response.data.text()  // Blob을 텍스트로 변환
      .then(text => {
        try {
          // 텍스트를 JSON으로 파싱
          const responseData = JSON.parse(text);
          // 메시지 추출
          if (responseData?.result?.message) {
            errorMessage = responseData.result.message;
          }
        } catch (parseError) {
          console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
        }
        // Toast에 에러 메시지 표시
        $toast('error', errorMessage);
      });
  });
};
// 재직자/기업 END

// 학생/취업준비생 START
// 0. TAB 옆 count
const retrieveApprovedStuCountByOjfId = () => {
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveApprovedStuCountByOjfId(ojfId.value)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalCnt21.value = result.totalCnt21;
                totalCnt22.value = result.totalCnt22;
                totalCnt23.value = result.totalCnt23;
                totalCnt24.value = result.totalCnt24;
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 1. 학생/취업준비생(2) - 참가회원(1) 리스트
const retrieveAllEntryStatusPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchJoinStateGb: _.map(searchInput21.value.joinStateGbsList).join(','),
        searchType: searchInput21.value.searchType,
        searchInput: searchInput21.value.searchInput,
        startApprovedYmd: searchInput21.value.searchApprovedDurationType === 'all' ? '' : searchInput21.value.startApprovedYmd,
        endApprovedYmd: searchInput21.value.searchApprovedDurationType === 'all' ? '' : searchInput21.value.endApprovedYmd,
        startYmd: searchInput21.value.searchDurationType === 'all' ? '' : searchInput21.value.startYmd,
        endYmd: searchInput21.value.searchDurationType === 'all' ? '' : searchInput21.value.endYmd,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveAllEntryStatusPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                stuList21.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 2. 학생/취업준비생(2) - 이력서(2) 리스트
const retrieveApprovedOjfResumeListAdminPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchInterests: _.map(searchInput22.value.searchInterests).join(','),
        searchApplyStateGbs: _.map(searchInput22.value.searchApplyStateGbs).join(','),
        searchIntvInYn: searchInput22.value.searchIntvInYn,
        searchIntvAbleDay: _.map(searchInput22.value.searchIntvAbleDay).join(','),
        startYmd: searchInput22.value.searchDurationType === 'all' ? '' : searchInput22.value.startYmd,
        endYmd: searchInput22.value.searchDurationType === 'all' ? '' : searchInput22.value.endYmd,
        searchType: searchInput22.value.searchType,
        searchInput: searchInput22.value.searchInput,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveApprovedOjfResumeListAdminPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                stuList22.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
}

// 2. 학생/취업준비생(2) - 이력서(2) 리스트 - 입사지원 리스트
const retrieveApplicantListByResumeIdPaging = (resumeId) => {
  let paramObj = {
    ojfId: ojfId.value,
    resumeId: resumeId,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }

  loadingStore.loading = true;
  adminApprovedJoinStateService.retrieveApplicantListByResumeIdPaging(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          applicantList2.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 3. 학생/취업준비생(2) - 입사지원(3) 리스트
const retrieveAllApplicantListPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchInterests: _.map(searchInput23.value.searchInterests).join(','),
        searchApplyStateGbs: _.map(searchInput23.value.searchApplyStateGbs).join(','),
        searchIntvInYn: searchInput23.value.searchIntvInYn,
        searchIntvAbleDay: _.map(searchInput23.value.searchIntvAbleDay).join(','),
        startYmd: searchInput23.value.searchDurationType === 'all' ? '' : searchInput23.value.startYmd,
        endYmd: searchInput23.value.searchDurationType === 'all' ? '' : searchInput23.value.endYmd,
        searchType: searchInput23.value.searchType,
        searchInput: searchInput23.value.searchInput,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveAllApplicantListPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                stuList23.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 4. 학생/취업준비생(2) - 받은 면접제안(4) 리스트
const retrieveAllInterviewProposalEntryListPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchInterests: _.map(searchInput24.value.searchInterests).join(','),
        searchIntvPropStateGbs: _.map(searchInput24.value.searchIntvPropStateGbs).join(','),
        searchIntvInYn: searchInput24.value.searchIntvInYn,
        searchIntvAbleDay: _.map(searchInput24.value.searchIntvAbleDay).join(','),
        startYmd: searchInput24.value.searchDurationType === 'all' ? '' : searchInput24.value.startYmd,
        endYmd: searchInput24.value.searchDurationType === 'all' ? '' : searchInput24.value.endYmd,
        searchType: searchInput24.value.searchType,
        searchInput: searchInput24.value.searchInput,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminApprovedJoinStateService.retrieveAllInterviewProposalEntryListPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                stuList24.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};
// 5. 학생/취업준비생 - '엑셀 다운로드' 클릭
const onClickStuExcelDownload = async () => {
  const ok = await $confirm(["학생/취업준비생 참가신청 목록을 내 PC로 다운로드할까요?"], "다운로드");
  if(ok){
    retrieveApprovedEntryStatusExcel();
  }
}

// 5-1. 학생/취업준비생 - 엑셀 다운로드
const retrieveApprovedEntryStatusExcel = () => {
  let paramObj = {
    ojfId: ojfId.value,
    pageSource: 'approved',
    searchJoinStateGb: _.map(searchInput21.value.joinStateGbsList).join(','),
    searchType: searchInput21.value.searchType,
    searchInput: searchInput21.value.searchInput,
    startYmd: searchInput21.value.searchDurationType === 'all' ? '' : searchInput21.value.startYmd,
    endYmd: searchInput21.value.searchDurationType === 'all' ? '' : searchInput21.value.endYmd,
    startApprovedYmd: searchInput21.value.searchApprovedDurationType === 'all' ? '' : searchInput21.value.startApprovedYmd,
    endApprovedYmd: searchInput21.value.searchApprovedDurationType === 'all' ? '' : searchInput21.value.endApprovedYmd,
  }
  $toast('', `다운로드 데이터 생성을 시작합니다.`);
  loadingStore.loading = true;
  adminApprovedJoinStateService.retrieveApprovedEntryStatusExcel(paramObj)
    .then( async (res) => {
      loadingStore.loading = false;
      try {

        const href = URL.createObjectURL(res.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `${ ojfDetail.value.ojfName }_${moment().format("YYYYMMDD")}_학생/취업준비생 참가신청 리스트.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      } catch(e) {
        console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
      }
    }).catch((err) => {
    loadingStore.loading = false;
    let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
    // Blob 응답 처리
    err.response.data.text()  // Blob을 텍스트로 변환
      .then(text => {
        try {
          // 텍스트를 JSON으로 파싱
          const responseData = JSON.parse(text);
          // 메시지 추출
          if (responseData?.result?.message) {
            errorMessage = responseData.result.message;
          }
        } catch (parseError) {
          console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
        }
        // Toast에 에러 메시지 표시
        $toast('error', errorMessage);
      });
  });
};
// 학생/취업준비생 END

// 공통 함수 START
// 신청정보 보기 - 재직자/기업
const onClickRecruitmentHallCorp = async (corpId) => {
  await recruitmentHallCorpModal.value.recruitmentHallCorpDetail(ojfId.value, corpId);
  await recruitmentHallCorpModal.value.show();
}

// 신청정보 보기 - 구직자
const onClickRecruitmentHall = async (userId) => {
  await recruitmentHallModal.value.recruitmentHallDetail(ojfId.value, userId);
  await recruitmentHallModal.value.show();
}

// 이력서 보기
const onClickMyResume = (resumeId) => {
  jobFairResumeModal.value.init(false);
  jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId.value);
  jobFairResumeModal.value.show();
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId) => {
  let mode;
  if (ojfGb.value === '01') {
    mode = 'openRecruitment'
  }
  jobNoticeModal.value.init(false, false, false, ojfId.value, undefined, undefined, undefined, undefined, undefined, mode);
  jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
  jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId.value, corpId);
  jobNoticeModal.value.ojfCorporationDetail(corpId);
  await jobNoticeModal.value.show();
}

// 채용공고 수정
const onClickJobNoticeUpdate = (jobNoticeSeq) => {
  router.push({ name: 'JobNoticeUpdate', query : { jobNoticeSeq: jobNoticeSeq, mode: 'approved', ojfGb: ojfGb.value }});
}

// 채용공고 삭제
const onClickDelete = async (jobNoticeSeq) => {
  const ok = await $confirm(["채용공고를 삭제하시겠습니까?"], "삭제");
  if(!ok) {
    return -1;
  } else {
    jobFairCorpService.ojfCropJobNoticeDelete ( jobNoticeSeq )
        .then((res) => {
          loadingStore.loading = true;
          if(res.data.code.toLowerCase() === 'success') {
            $alert(["채용공고가 삭제되었습니다."]);
            retrieveJobNoticeListPaging();
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          // console.log(res);
          $alert([res.response.data.result.message]);
        });
  }
}

// 인재정보 공개 여부
const onClickChangeResOpenYn = async (userId, resumeId, resOpenYn) => {
  let ok = false;

  // 기존에 오픈된 이력서 존재 여부 확인. true/false
  const resumeY = stuList22.value.some(item => item.resOpenYn === 'Y');

  // resOpenYn Y인지 아닌지 check
  if ( resOpenYn === 'Y') { // 공개
    if ( stuList22.value.length > 1 ) { // 오픈된 기존 이력서가 존재할 경우
      if ( resumeY ) {
        ok = await jobFairResumeOpenModal.value.show(false);
      } else { // 오픈된 기존 이력서가 존재하지 않을 경우
        ok = await $confirm(["해당 이력서를 공개 하시겠습니까?"], "확인");
      }
    }
  } else { // 비공개
    ok = await $confirm(["해당 이력서를 비공개 하시겠습니까?"], "확인");
  }

  if ( ok ) {
    let paramObj = {
      userId: userId,
      resumeId: resumeId,
      ojfId: ojfId.value,
      resOpenYn: resOpenYn,
    }
    adminApprovedJoinStateService.updateStatusOjfResumeResOpenYnByAdmin(paramObj)
        .then( async (res) => {
          if (res.data.code.toLowerCase() === 'success') {
            //let result = res.data.result;
            //console.log(result);
            if(resOpenYn === 'Y') {
              $alert(["선택한 이력서가", "특별채용관 인재정보에 공개되었습니다."]);
            } else if(resOpenYn === 'N') {
              $alert(["선택한 이력서가", "특별채용관 인재정보에 비공개되었습니다."]);
            }
            loadingStore.loading = false;
            retrieveApprovedOjfResumeListAdminPaging();
          }
        }).catch((error) => {
          loadingStore.loading = false;
        });
  }
}

// 입사지원 상태변경 joinStateGb
const onClickApplyStateGb = async (resumeId, jobNoticeSeq, stateGb) => {
  let message, okButtonText;
  if (stateGb === "02") {
    message = ["지원취소 처리하시겠습니까??", "'지원취소'으로 상태가 변경됩니다."];
    okButtonText = "지원취소";
  } else if (stateGb === "03") {
    message = ["서류합격 처리하시겠습니까??", "'서류합격'으로 상태가 변경됩니다."];
    okButtonText = "서류합격";
  } else if (stateGb === "04") {
    message = ["서류불합격 처리하시겠습니까??", "'서류불합격'으로 상태가 변경됩니다."];
    okButtonText = "서류불합격";
  } else if (stateGb === "05") {
    message = ["최종합격 처리하시겠습니까??", "'최종합격'으로 상태가 변경됩니다."];
    okButtonText = "최종합격";
  } else if (stateGb === "06") {
    message = ["최종불합격 처리하시겠습니까??", "'최종불합격'으로 상태가 변경됩니다."];
    okButtonText = "최종불합격";
  }

  const ok = await $confirm(message, okButtonText);
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      ojfId: ojfId.value,
      jobNoticeSeq: jobNoticeSeq,
      applyStateGb: stateGb,
    }
    jobFairUserService.ojfUpdateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert(["변경 하였습니다."]);
            //$toast('', "삭제를 하였습니다.")
            if(tabIndex.value === 1) { // 재직자/기업
              if(tabIndex2.value === 2) {
                retrieveOjfResumeListByByJobNoticeSeqAdminPaging(jobNoticeSeq);
              } else if(tabIndex2.value === 3) {
                retrieveAllOjfResumeListAdminPaging();
              }
            } else if(tabIndex.value === 2) { // 학생/취업준비생
              if(tabIndex2.value === 2) {
                retrieveApplicantListByResumeIdPaging(resumeId);
              } else if(tabIndex2.value === 3) {
                retrieveAllApplicantListPaging();
              }
            }
          } else {
            $alert(["변경을 실패하였습니다."]);
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          $alert(["변경을 실패하였습니다."]);
        });
  }
}

// 받은 면접제안 상태변경
const onClickIntvPropState = async (resumeId, jobNoticeSeq, stateGb) => {
  let message, okButtonText;
  if (stateGb === '02') {
    message = ["면접 제안을 수락하시겠습니까?", "'제안수락'으로 상태가 변경됩니다."];
    okButtonText = "제안 수락";
  } else if(stateGb === '03') {
    message = ["면접 제안을 거절하시겠습니까?", "'제안거절'로 상태가 변경됩니다."];
    okButtonText = "제안 거절";
  } else if(stateGb === '05') {
    message = ["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."];
    okButtonText = "최종합격";
  } else if(stateGb === '06') {
    message = ["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."];
    okButtonText = "최종불합격";
  } else if(stateGb === '04') {
    message = ["제안취소 처리하시겠습니까?", "'제안취소'으로 상태가 변경됩니다."];
    okButtonText = "제안취소";
  }
  const ok = await $confirm(message, okButtonText);
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      jobNoticeSeq: jobNoticeSeq,
      intvPropStateGb: stateGb,
    }
    jobFairUserService.ojfUpdateIntvPropsState(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert(["변경 하였습니다."]);

            if(tabIndex.value === 1 && tabIndex2.value === 4) {
              retrieveAllInterviewProposalEntryListByOjfIdPaging();
            } else{
              retrieveAllInterviewProposalEntryListPaging();
            }
          } else {
            $alert(["변경을 실패하였습니다."]);
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          $alert(["변경을 실패하였습니다."]);
        });
  }
}
// 공통 함수 END

// tabIndex 변경
const onChangeTab = async ({ value }) => {
    tabIndex.value = value;
    tabIndex2.value = 1;

    currentPage.value = 1;
    pageSize.value = 10;
    searchOpen.value = true;
    viewMode.value = BASIC;

    await ojfIntvDay();
    await clearSearchInput();
    retrieveList();
}

// tabIndex2 변경
const onChangeTab2 = async ({ value }) => {
    tabIndex2.value = value;

    currentPage.value = 1;
    pageSize.value = 10;
    searchOpen.value = true;
    viewMode.value = BASIC;

    await ojfIntvDay();
    await clearSearchInput();

    retrieveList();
}

// 페이지 선택
const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
};

// 페이지 사이즈 변경. 10,30,50,100
const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
}

// 검색 - searchType 셀렉트 박스 선택시
const onSelectSearchTypeGroup = (option) => {
    if(tabIndex.value === 1) {
        if(tabIndex2.value === 1) {
            searchInput11.value.searchType = option.value;
        } else if(tabIndex2.value === 2) {
            searchInput12.value.searchType = option.value;
        } else if(tabIndex2.value === 3) {
            searchInput13.value.searchType = option.value;
        } else if(tabIndex2.value === 4) {
            searchInput14.value.searchType = option.value;
        }
    } else if(tabIndex.value === 2) {
        if(tabIndex2.value === 1) {
            searchInput21.value.searchType = option.value;
        } else if(tabIndex2.value === 2) {
            searchInput22.value.searchType = option.value;
        } else if(tabIndex2.value === 3) {
            searchInput23.value.searchType = option.value;
        } else if(tabIndex2.value === 4) {
            searchInput24.value.searchType = option.value;
        }
    }
}

// 검색 - '초기화' 버튼 클릭
const clearSearchInput = () => {
    if(tabIndex.value === 1) { // 재직자/기업
        if(tabIndex2.value === 1) {
            searchInput11.value = {
                searchType: 'corpName', // corpName 기업명, userName 이름, id 아이디, code 회원코드
                searchInput: '',
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
                searchApprovedDurationType: 'all',
                startApprovedYmd: '',
                endApprovedYmd: '',
                joinStateGbsList: ['11'],
            }
            searchTypeRef.value.initSelectedOption(searchInput11.value.searchType);
        } else if(tabIndex2.value === 2) {
            searchInput12.value = {
                searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                searchIntvGbs: ['01', '02', '03', '04'],
                searchIntvInYn: 'A',
                searchIntvAbleDay: ojfIntvDays.value,
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
                searchType: 'corpName', // corpName 기업명, title 채용공고제목, name 등록마스터
                searchInput: '',
            }
            searchTypeRef.value.initSelectedOption(searchInput12.value.searchType);
            interestsListRef.value.initOptionsWithValues(searchInput12.value.searchInterests); // 관심 카테고리
            intvsListRef.value.initOptionsWithValues(searchInput12.value.searchIntvGbs); // 면접 방식
            intvDaysListRef.value.initOptionsWithValues(searchInput12.value.searchIntvAbleDay); // 면접 가능일
        } else if(tabIndex2.value === 3) {
            searchInput13.value = {
                searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
                searchIntvInYn: 'A',
                searchIntvAbleDay: ojfIntvDays.value,
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
                searchType: 'name', // name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명
                searchInput: '',
            }
            searchTypeRef.value.initSelectedOption(searchInput13.value.searchType);
            interestsListRef.value.initOptionsWithValues(searchInput13.value.searchInterests); // 관심 카테고리
            applyStateGbsListRef.value.initOptionsWithValues(searchInput13.value.searchApplyStateGbs); // 지원 상태
            intvDaysListRef.value.initOptionsWithValues(searchInput13.value.searchIntvAbleDay); // 면접 가능일
        } else if(tabIndex2.value === 4) {
            searchInput14.value = {
              searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
              searchIntvPropStateGbs: ['01', '02', '03', '04', '05', '06'],
              searchIntvInYn: 'A',
              searchIntvAbleDay: ojfIntvDays.value,
              searchDurationType: 'all',
              startYmd: '',
              endYmd: '',
              searchType: 'name', // name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명
              searchInput: '',
            }
            searchTypeRef.value.initSelectedOption(searchInput14.value.searchType);
            interestsListRef.value.initOptionsWithValues(searchInput14.value.searchInterests); // 관심 카테고리
            adminIntvPropStateGbsListRef.value.initOptionsWithValues(searchInput14.value.searchIntvPropStateGbs); // 지원 상태
            intvDaysListRef.value.initOptionsWithValues(searchInput14.value.searchIntvAbleDay); // 면접 가능일
        }
    } else if(tabIndex.value === 2) { // 학생/취업준비생
        if(tabIndex2.value === 1) {
            searchInput21.value = {
                searchType: 'userName', // userName 이름, id 아이디, code 회원코드
                searchInput: '',
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
                searchApprovedDurationType: 'all',
                startApprovedYmd: '',
                endApprovedYmd: '',
                joinStateGbsList: ['11'],
            }
            searchTypeRef.value.initSelectedOption(searchInput21.value.searchType);
        } else if(tabIndex2.value === 2) {
            searchInput22.value = {
                searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                searchIntvInYn: 'A',
                searchIntvAbleDay: ojfIntvDays.value,
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
                searchType: 'name', // corpName 기업명, title 채용공고제목, name 등록마스터
                searchInput: '',
            }
            searchTypeRef.value.initSelectedOption(searchInput22.value.searchType);
            interestsListRef.value.initOptionsWithValues(searchInput22.value.searchInterests); // 관심 카테고리
            intvDaysListRef.value.initOptionsWithValues(searchInput22.value.searchIntvAbleDay); // 면접 가능일
        } else if(tabIndex2.value === 3) {
            searchInput23.value = {
                searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
                searchIntvInYn: 'A',
                searchIntvAbleDay: ojfIntvDays.value,
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
                searchType: 'applicantName', // applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목
                searchInput: '',
            }
            searchTypeRef.value.initSelectedOption(searchInput23.value.searchType);
            interestsListRef.value.initOptionsWithValues(searchInput23.value.searchInterests); // 관심 카테고리
            applyStateGbsListRef.value.initOptionsWithValues(searchInput23.value.searchApplyStateGbs); // 지원 상태
            intvDaysListRef.value.initOptionsWithValues(searchInput23.value.searchIntvAbleDay); // 면접 가능일
        } else if(tabIndex2.value === 4) {
            searchInput24.value = {
                searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                searchIntvPropStateGbs: ['01', '02', '03', '04', '05', '06'],
                searchIntvInYn: 'A',
                searchIntvAbleDay: ojfIntvDays.value,
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
                searchType: 'applicantName', // applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목
                searchInput: '',
            }
            searchTypeRef.value.initSelectedOption(searchInput24.value.searchType);
            interestsListRef.value.initOptionsWithValues(searchInput24.value.searchInterests); // 관심 카테고리
            intvPropStateGbsListRef.value.initOptionsWithValues(searchInput24.value.searchIntvPropStateGbs); // 면접 제안 상태
            intvDaysListRef.value.initOptionsWithValues(searchInput24.value.searchIntvAbleDay); // 면접 가능일
        }
    }
}

// 검색 - '검색' 버튼 click
const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
}

// tab별 리스트 불러 오기 공통 함수
const retrieveList = () => {
    if(tabIndex.value === 1) { // 재직자/기업
        if(tabIndex2.value === 1) {
            retrieveApprovedRecruitmentHallPaging();
        } else if(tabIndex2.value === 2) {
            if(viewMode.value === RETRIEVE_APPLICANT) {
              retrieveOjfResumeListByByJobNoticeSeqAdminPaging(detailCommonId.value);
            } else {
              retrieveJobNoticeListPaging();
            }
        } else if(tabIndex2.value === 3) {
            retrieveAllOjfResumeListAdminPaging();
        } else if(tabIndex2.value === 4) {
            retrieveAllInterviewProposalEntryListByOjfIdPaging();
        }
    } else if(tabIndex.value === 2) { // 학생/취업준비생
        if(tabIndex2.value === 1) {
            retrieveAllEntryStatusPaging();
        } else if(tabIndex2.value === 2) {
            if(viewMode.value === RETRIEVE_APPLICANT2) {
              retrieveApplicantListByResumeIdPaging(detailCommonId.value);
            } else {
              retrieveApprovedOjfResumeListAdminPaging();
            }
        } else if(tabIndex2.value === 3) {
            retrieveAllApplicantListPaging();
        } else if(tabIndex2.value === 4) {
            retrieveAllInterviewProposalEntryListPaging();
        }
    }
    // viewMode.value = BASIC;
}

// 참가 현황 목록으로 이동
const goApprovedJoinState = () => {
    router.push({ name: "ApprovedJoinState" });
}

// 행사 상세로 이동
const goOjfDetail = () => {
    router.push({ name: 'OjfDetail', params:{id: ojfId.value} })
}

// 행사 상세 새 창으로 열기
const openOjfDetailInNewWindow = () => {
    const url = router.resolve({
        name: 'OjfDetail',
        params: { id: ojfId.value },
    }).href;

    const windowFeatures = 'width=1000,height=800,top=100,left=100,resizable=yes,scrollbars=yes';
    window.open(url, '_blank', windowFeatures);
}

// 면접 가능일 전체인지 확인 후 문구 표시
// 재직자/기업 - 채용공고
const allDays1 = computed(() => corpList12.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected1 = computed(() => (ojfIntvDays.value || []).length === allDays1.value.length)
// 재직자/기업 - 채용공고 - 입사지원
const allDays2 = computed(() => applicantList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected2 = computed(() => (ojfIntvDays.value || []).length === allDays2.value.length)
// 재직자/기업 - 입사지원
const allDays3 = computed(() => corpList13.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected3 = computed(() => (ojfIntvDays.value || []).length === allDays3.value.length)
// 학생/취업준비생 - 이력서
const allDays4 = computed(() => stuList22.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected4 = computed(() => (ojfIntvDays.value || []).length === allDays4.value.length)
// 학생/취업준비생 - 이력서 - 입사지원
const allDays5 = computed(() => applicantList2.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected5 = computed(() => (ojfIntvDays.value || []).length === allDays5.value.length)
// 학생/취업준비생 - 입사지원
const allDays6 = computed(() => stuList23.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected6 = computed(() => (ojfIntvDays.value || []).length === allDays6.value.length)
// 학생/취업준비생 - 받은 면접제안
const allDays7 = computed(() => stuList24.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected7 = computed(() => (ojfIntvDays.value || []).length === allDays7.value.length)

// 뒤로
const goBack = () => {
    router.go(-1);
}

// 기업명 새 탭
const openOjfDetailInNewTab = (linkName, Id) => {
  const url = router.resolve({
    name: linkName,
    params: { id: Id },
  }).href;

  window.open(url, '_blank');
}
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>{{ ojfDetail.ojfName }}</h3>
        </div>
        <div class="list-top space-between">
            <KSASecondaryButton class="gray_button" text="목록" @click="goApprovedJoinState" />
            <div>
                <KSASecondaryButton class="gray_button ml-xs" text="행사 상세 새 창 보기" @click="openOjfDetailInNewWindow" />
            </div>
        </div>
        <KSATab style="grid-template-columns: repeat(2, 1fr);" class="mb-sm"
            :options="tabOptions"
            @change="onChangeTab"
        />

                <!-- s: tabIndex 1 : 재직자/기업 ------------------------------------------------------------------->
                <div v-if="tabIndex === 1">
                    <KSATab style="grid-template-columns: repeat(4, 1fr);" class="mb-lg"
                        :options="[
                                    {label: `참가기업${'(' + totalCnt11 + ')'}`, value: 1},
                                    {label: `채용공고${'(' + totalCnt12 + ')'}`, value: 2},
                                    {label: `입사지원${'(' + totalCnt13 + ')'}`, value: 3},
                                    {label: `면접제안 인재${'(' + totalCnt14 + ')'}`, value: 4},
                                  ]"
                        @change="onChangeTab2"
                    />

            <!-- s: tabIndex2 1 : 참가기업 ----------------------------------------------------------------->
            <div v-if="tabIndex2 === 1">
                <!-- s: 검색 -->
                <div class="filter-wrap" :class="{'open': searchOpen}">
                    <p @click="searchOpen = !searchOpen">검색</p>
                    <div class="filter">
                        <!-- corpName 기업명, userName 이름, id 아이디, code 회원코드 검색 -->
                        <dl>
                            <dt>
                                <KSASelect ref="searchTypeRef" :options="searchTypeGroup11" class="select" @selectOption="onSelectSearchTypeGroup"/>
                            </dt>
                            <dd>
                                <KSAInput class="text-box" v-model="searchInput11.searchInput" :placeholder="searchInputPlaceholder11" />
                            </dd>
                        </dl>
                        <dl>
                            <dt>승인일<br/>(참가확정)</dt>
                            <dd class="text-box">
                                <div class="grid">
                                    <template v-for="group in searchApprovedDurationTypeGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput11.searchApprovedDurationType" :value="group.value" />
                                    </template>
                                    <div style="display: inline-block;" v-if="searchInput11.searchApprovedDurationType !== 'all'">
                                        <KSADatepickerTerms
                                            :startDate="searchInput11.startApprovedYmd"
                                            :endDate="searchInput11.endApprovedYmd"
                                            @update:startDate="(value)=> searchInput11.startApprovedYmd = value"
                                            @update:endDate="(value)=> searchInput11.endApprovedYmd = value"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <dl>
                            <dt>참가 신청일</dt>
                            <dd class="text-box">
                                <div class="grid">
                                    <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput11.searchDurationType" :value="group.value" />
                                    </template>
                                    <div style="display: inline-block;" v-if="searchInput11.searchDurationType !== 'all'">
                                        <KSADatepickerTerms
                                            :startDate="searchInput11.startYmd"
                                            :endDate="searchInput11.endYmd"
                                            @update:startDate="(value)=> searchInput11.startYmd = value"
                                            @update:endDate="(value)=> searchInput11.endYmd = value"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <div class="btn-wrap">
                            <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                            <KSAPrimaryButton text="검색" @click="onClickSearch" />
                        </div>
                    </div>
                </div>
                <!-- e: 검색 -->
                <!-- s: 버튼영역 -->
                <div class="list-top">
                  <div class="grid">
                    <KSAPrimaryButton v-if="tabIndex2 === 1" text="엑셀 다운로드" @click="onClickCorpExcelDownload" />
                  </div>
                  <div>
                    <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                  </div>
                </div>
                <!-- e: 버튼영역 -->
                <div class="table-form">
                    <table class="horizontal" v-if="corpList11 !== null">
                        <tr>
                            <th rowspan="2">NO</th>
                            <th rowspan="2">참가 상태</th>
                            <th rowspan="2" class="border-right">기업명</th>
                            <th colspan="3">마스터</th>
                            <th rowspan="2">승인일(참가확정)</th>
                            <th rowspan="2">참가 신청일</th>
                            <th rowspan="2">신청정보</th>
                            <th rowspan="2">신청 채용공고</th>
                        </tr>
                        <tr>
                            <th>회원코드</th>
                            <th>이름</th>
                            <th>아이디</th>
                        </tr>
                        <tr v-for="ojf in corpList11">
                            <td>{{ ojf.boardNo }}</td>
                            <td>
                                <span :class="ojf.joinStateGb === '11' ? 'blue' : ojf.joinStateGb === '21' ? 'red' : ojf.joinStateGb === '03' || ojf.joinStateGb === '04' ? 'gray' : ''">{{ $gbNameKR("ADMIN_JOIN_STATE_GB", ojf.joinStateGb) }}</span>
                            </td>
                            <td class="clickable blue">
                                <span @click="openOjfDetailInNewTab('CorporationDetail', ojf.corpId)">{{ ojf.corpName }}</span>
                            </td>
                            <td>{{ ojf.userCd }}</td>
                            <td class="clickable blue">
                              <span @click="openOjfDetailInNewTab('MemberDetail', ojf.userCd)">{{ ojf.userName }}</span>
                            </td>
                            <td>{{ ojf.userLoginId }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.joinStateModifyDate) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td class="clickable blue" @click="onClickRecruitmentHallCorp(ojf.corpId )">신청정보</td>
                            <td class="clickable blue" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">채용공고</td>
                        </tr>
                    </table>
                    <div class="result-none" v-if="corpList11.length === 0">
                        참가 기업이 없습니다.
                    </div>
                </div>
                <Paginate
                    v-if="corpList11.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
            </div>
            <!-- e: tabIndex2 1 : 참가기업 ----------------------------------------------------------------->

            <!-- s: tabIndex2 2 : 채용공고 ----------------------------------------------------------------->
            <div v-else-if="tabIndex2 === 2">
                <div v-show="viewMode === BASIC">
                  <!-- s: 검색 -->
                  <div class="filter-wrap" :class="{'open': searchOpen}">
                    <p @click="searchOpen = !searchOpen">검색</p>
                    <div class="filter">
                      <dl>
                        <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                        <dd>
                          <KSACheckBoxGroup
                              ref="interestsListRef"
                              className="mr-md"
                              name="interestsList"
                              v-model="searchInput12.searchInterests"
                              :options="data_interests"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt style="display:block;">면접 방식</dt>
                        <dd>
                          <KSACheckBoxGroup
                              ref="intvsListRef"
                              className="mr-md"
                              name="intvsList"
                              v-model="searchInput12.searchIntvGbs"
                              :options="data_intvGb"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>면접 가능일</dt>
                        <dd class="text-box">
                          <template v-for="group in searchCorpIntvInYnGroup" key="item.value" >
                            <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput12.searchIntvInYn" :value="group.value" />
                          </template>
                        </dd>
                      </dl>
                      <dl v-show="searchInput12.searchIntvInYn === 'Y'">
                        <dt></dt>
                        <dd>
                          <KSACheckBoxGroup
                              ref="intvDaysListRef"
                              className="mr-md"
                              name="intvDaysList"
                              v-model="searchInput12.searchIntvAbleDay"
                              :options="ojfIntvDayList"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>등록일</dt>
                        <dd class="text-box">
                          <div class="grid">
                            <template v-for="group in searchDurationTypeGroup" key="item.value" >
                              <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput12.searchDurationType" :value="group.value" />
                            </template>
                            <div style="display: inline-block;" v-if="searchInput12.searchDurationType !== 'all'">
                              <KSADatepickerTerms
                                  :startDate="searchInput12.startYmd"
                                  :endDate="searchInput12.endYmd"
                                  @update:startDate="(value)=> searchInput12.startYmd = value"
                                  @update:endDate="(value)=> searchInput12.endYmd = value"
                              />
                            </div>
                          </div>
                        </dd>
                      </dl>
                      <!-- corpName 기업명, title 채용공고제목, name 등록마스터 검색 -->
                      <dl>
                        <dt>
                          <KSASelect ref="searchTypeRef" :options="searchTypeGroup12" class="select" @selectOption="onSelectSearchTypeGroup"/>
                        </dt>
                        <dd>
                          <KSAInput class="text-box" v-model="searchInput12.searchInput" :placeholder="searchInputPlaceholder12" />
                        </dd>
                      </dl>


                              <div class="btn-wrap">
                                <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                                <KSAPrimaryButton text="검색" @click="onClickSearch" />
                              </div>
                            </div>
                          </div>
                          <!-- e: 검색 -->
                          <!-- s: 버튼영역 -->
                          <div class="list-top" style="justify-content: flex-end;">
                            <div>
                              <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                            </div>
                          </div>
                          <!-- e: 버튼영역 -->
                          <div class="table-form">
                            <table class="horizontal" v-if="corpList12 !== null">
                              <tr>
                                <th>NO</th>
                                <th>기업명</th>
                                <th>채용공고 제목</th>
                                <th>등록 마스터</th>
                                <th>관심 카테고리</th>
                                <th>면접 가능일</th>
                                <th>면접 방식</th>
                                <th>입사지원</th>
                                <th>최근 수정일</th>
                                <th>등록일</th>
                                <th>관리</th>
                              </tr>
                              <tr v-for="ojf in corpList12">
                                <td>{{ ojf.boardNo }}</td>
                                <td class="clickable blue">
                                  <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                                </td>
                                <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                                <td class="clickable blue">
                                  <RouterLink :to="{name:'MemberDetail', params:{id: ojf.createId}}">{{ ojf.userName }}</RouterLink>
                                </td>
                                <td>{{ ojf.interests }}</td>
                                <td class="word-break-all">
                                  <span v-if="ojf.intvInYn === 'Y' && isAllSelected1">
                                    전체 일정 가능
                                    [{{ ojf.intvAbleDay }}]
                                  </span>
                                  <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                  <span v-else>면접 일정 조율</span>
                                </td>
                                <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                                <td class="clickable blue" @click="setViewMode(RETRIEVE_APPLICANT, ojf.jobNoticeSeq, ojf.corpId, ojf.fileYn)">{{ ojf.applicantCnt }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                <td>
                                  <!-- 승인/반려 처리 이전 = 수정가능, 삭제 불가 -->
                                  <!-- 승인처리 이후 + 입사지원 없는 경우 = 수정가능, 삭제 가능 -->
                                  <div v-if="ojf.modifyYn === 'Y'">
                                    <KSATextButton class="clickable" text="수정" @click="onClickJobNoticeUpdate(ojf.jobNoticeSeq)"/>
                                  </div>
                                  <div v-if="ojf.deleteYn === 'Y'">
                                    <KSATextButton class="clickable red_button" text="삭제" @click="onClickDelete(ojf.jobNoticeSeq)"/>
                                  </div>
                                  <div v-if="ojf.modifyYn === 'N' && ojf.deleteYn === 'N'"> - </div>
                                </td>
                              </tr>
                            </table>
                            <div class="result-none" v-if="corpList12.length === 0">
                              등록된 채용공고가 없습니다.
                            </div>
                          </div>
                          <Paginate
                              v-if="corpList12.length > 0"
                              v-model="currentPage"
                              :page-count="totalPages"
                              :click-handler="onSelectPage"
                          />
                        </div>
                        <!-- s: tabIndex2 2 : 채용공고 - 입사지원 상세 ------------------------------------------------->
                        <div v-show="viewMode !== BASIC">
                            <div v-if="viewMode === RETRIEVE_APPLICANT">
                                <KSASecondaryButton text="이전" @click="setViewMode(BASIC)" />
                                <div class="list-top">
                                  <p>총 <span>{{ $number(totalCount)}}</span>명</p>
                                  <div>
                                    <KSAPrimaryButton text="채용공고 보기" @click="onClickJobNotice(detailCommonId, detailCommonData)" />
                                  </div>
                                </div>
                                <div class="table-form">
                                  <table class="horizontal" v-if="applicantList !== null">
                                    <tr>
                                      <th>NO</th>
                                      <th>회원코드</th>
                                      <th>이름</th>
                                      <th>아이디</th>
                                      <th>이력서 제목</th>
                                      <th v-show="detailCommonData2 === 'N'">관심 카테고리</th>
                                      <th>면접 가능일</th>
                                      <th>입사 지원일</th>
                                      <th>상태</th>
                                      <th>상태변경</th>
                                    </tr>
                                    <tr v-for="ojf in applicantList">
                                      <td>{{ ojf.boardNo }}</td>
                                      <td>{{ ojf.userCd }}</td>
                                      <td class="clickable blue">
                                        <RouterLink :to="{name: 'MemberDetail', params:{id: ojf.userCd}}">{{ ojf.userName }}</RouterLink>
                                      </td>
                                      <td>{{ ojf.userLoginId }}</td>
                                      <td class="text-overflow long-overflow">
                                        <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                          {{ resumeAttaches.fileName }}
                                        </span>
                                        <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                          {{ ojf.title }}
                                        </span>
                                      </td>
                                      <td v-show="detailCommonData2 === 'N'">{{ ojf.interests }}</td>
                                      <td class="word-break-all">
                                        <span v-if="ojf.intvInYn === 'Y' && isAllSelected2">
                                          전체 일정 가능
                                          [{{ ojf.intvAbleDay }}]
                                        </span>
                                        <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                        <span v-else>면접 일정 조율</span>
                                      </td>
                                      <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                      <td>
                                        <span v-if="ojf.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                        <span v-else-if="ojf.applyStateGb === '03' || ojf.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                        <span v-else-if="ojf.applyStateGb === '04' || ojf.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                        <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                      </td>
                                      <td>
                                        <div v-if="ojf.applyStateGb === '01'">
                                          <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '03')"/><br/>
                                          <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '04')"/>
                                        </div>
                                        <div v-else-if="ojf.applyStateGb === '03'">
                                          <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '04')"/><br/>
                                          <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '05')"/><br/>
                                          <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '06')"/>
                                        </div>
                                        <div v-else-if="ojf.applyStateGb === '04'">
                                          <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '03')"/>
                                        </div>
                                        <div v-else-if="ojf.applyStateGb === '05'">
                                          <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '06')"/>
                                        </div>
                                        <div v-else-if="ojf.applyStateGb === '06'">
                                          <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '05')"/>
                                        </div>
                                        <div v-else>
                                          -
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                  <div class="result-none" v-if="applicantList.length === 0">
                                    입사지원 내역이 없습니다.
                                  </div>
                                </div>
                              <Paginate
                                  v-if="applicantList.length > 0"
                                  v-model="currentPage"
                                  :page-count="totalPages"
                                  :click-handler="onSelectPage"
                              />
                            </div>
                        </div>
                        <!-- e: tabIndex2 2 : 채용공고 - 입사지원 상세------------------------------------------------>
                    </div>
                    <!-- e: tabIndex2 2 : 채용공고 ----------------------------------------------------------------->

                    <!-- s: tabIndex2 3 : 입사지원 ----------------------------------------------------------------->
                    <div v-else-if="tabIndex2 === 3">
                        <!-- s: 검색 -->
                        <div class="filter-wrap" :class="{'open': searchOpen}">
                            <p @click="searchOpen = !searchOpen">검색</p>
                            <div class="filter">
                                <dl>
                                    <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                    <dd>
                                        <KSACheckBoxGroup
                                            ref="interestsListRef"
                                            className="mr-md"
                                            name="interestsList"
                                            v-model="searchInput13.searchInterests"
                                            :options="data_interests"
                                        />
                                    </dd>
                                </dl>
                                <dl>
                                    <dt style="display:block;">상태</dt>
                                    <dd>
                                        <KSACheckBoxGroup
                                            ref="applyStateGbsListRef"
                                            className="mr-md"
                                            name="applyStateGbsList"
                                            v-model="searchInput13.searchApplyStateGbs"
                                            :options="data_applyStateGb"
                                        />
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>면접 가능일</dt>
                                    <dd class="text-box">
                                      <template v-for="group in searchStuIntvInYnGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput13.searchIntvInYn" :value="group.value" />
                                      </template>
                                    </dd>
                                </dl>
                                <dl v-show="searchInput13.searchIntvInYn === 'Y'">
                                  <dt></dt>
                                  <dd>
                                    <KSACheckBoxGroup
                                        ref="intvDaysListRef"
                                        className="mr-md"
                                        name="intvDaysList"
                                        v-model="searchInput13.searchIntvAbleDay"
                                        :options="ojfIntvDayList"
                                    />
                                  </dd>
                                </dl>
                                <dl>
                                    <dt>입사 지원일</dt>
                                    <dd class="text-box">
                                        <div class="grid">
                                            <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput13.searchDurationType" :value="group.value" />
                                            </template>
                                            <div style="display: inline-block;" v-if="searchInput13.searchDurationType !== 'all'">
                                                <KSADatepickerTerms
                                                    :startDate="searchInput13.startYmd"
                                                    :endDate="searchInput13.endYmd"
                                                    @update:startDate="(value)=> searchInput13.startYmd = value"
                                                    @update:endDate="(value)=> searchInput13.endYmd = value"
                                                />
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                                <!-- name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명 검색 -->
                                <dl>
                                    <dt>
                                        <KSASelect ref="searchTypeRef" :options="searchTypeGroup13" class="select" @selectOption="onSelectSearchTypeGroup"/>
                                    </dt>
                                    <dd>
                                        <KSAInput class="text-box" v-model="searchInput13.searchInput" :placeholder="searchInputPlaceholder13" />
                                    </dd>
                                </dl>
                                <div class="btn-wrap">
                                    <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                                    <KSAPrimaryButton text="검색" @click="onClickSearch" />
                                </div>
                            </div>
                        </div>
                        <!-- e: 검색 -->
                        <!-- s: 버튼영역 -->
                        <div class="list-top" style="justify-content: flex-end;">
                            <div>
                                <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                            </div>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                            <table class="horizontal" v-if="corpList13 !== null">
                                <tr>
                                    <th>NO</th>
                                    <th>회원코드</th>
                                    <th>이름</th>
                                    <th>아이디</th>
                                    <th>이력서 제목</th>
                                    <th>관심 카테고리</th>
                                    <th>면접 가능일</th>
                                    <th>입사지원 채용공고</th>
                                    <th>기업명</th>
                                    <th>입사지원일</th>
                                    <th>상태</th>
                                    <th>상태변경</th>
                                </tr>
                                <tr v-for="ojf in corpList13">
                                    <td>{{ ojf.boardNo }}</td>
                                    <td>{{ ojf.userCd }}</td>
                                    <td class="clickable blue">
                                        <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userCd}}">{{ ojf.userName }}</RouterLink>
                                    </td>
                                    <td>{{ ojf.userLoginId }}</td>
                                    <td class="text-overflow long-overflow">
                                      <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                        {{ resumeAttaches.fileName }}
                                      </span>
                                      <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                        {{ ojf.title }}
                                      </span>
                                    </td>
                                    <td>
                                      <span v-if="ojf.fileYn === 'Y'">-</span>
                                      <span v-else>{{ ojf.interests }}</span>
                                    </td>
                                    <td class="word-break-all">
                                        <span v-if="ojf.intvInYn === 'Y' && isAllSelected3">
                                          전체 일정 가능
                                          [{{ ojf.intvAbleDay }}]
                                        </span>
                                        <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                        <span v-else>면접 일정 조율</span>
                                    </td>
                                    <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                                    <td class="clickable blue">
                                      <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                                    </td>
                                    <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                    <td>
                                      <span v-if="ojf.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                      <span v-else-if="ojf.applyStateGb === '03' || ojf.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                      <span v-else-if="ojf.applyStateGb === '04' || ojf.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                      <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                    </td>
                                    <td>
                                      <div v-if="ojf.applyStateGb === '01'">
                                        <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '03')"/><br/>
                                        <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '04')"/>
                                      </div>
                                      <div v-else-if="ojf.applyStateGb === '03'">
                                        <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '04')"/><br/>
                                        <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '05')"/><br/>
                                        <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '06')"/>
                                      </div>
                                      <div v-else-if="ojf.applyStateGb === '04'">
                                        <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '03')"/>
                                      </div>
                                        <div v-else-if="ojf.applyStateGb === '05'">
                                        <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '06')"/>
                                      </div>
                                        <div v-else-if="ojf.applyStateGb === '06'">
                                        <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '05')"/>
                                      </div>
                                      <div v-else>
                                        -
                                      </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="result-none" v-if="corpList13.length === 0">
                                입사지원 내역이 없습니다.
                            </div>
                        </div>
                        <Paginate
                            v-if="corpList13.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                        />
                    </div>
                    <!-- e: tabIndex2 3 : 입사지원 ----------------------------------------------------------------->

                    <!-- s: tabIndex2 4 : 면접제안 인재 ----------------------------------------------------------------->
                    <div v-else-if="tabIndex2 === 4">
                        <!-- s: 검색 -->
                        <div class="filter-wrap" :class="{'open': searchOpen}">
                            <p @click="searchOpen = !searchOpen">검색</p>
                            <div class="filter">
                                <dl>
                                    <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                    <dd>
                                        <KSACheckBoxGroup
                                            ref="interestsListRef"
                                            className="mr-md"
                                            name="interestsList"
                                            v-model="searchInput14.searchInterests"
                                            :options="data_interests"
                                        />
                                    </dd>
                                </dl>
                                <dl>
                                    <dt style="display:block;">상태</dt>
                                    <dd>
                                        <KSACheckBoxGroup
                                            ref="adminIntvPropStateGbsListRef"
                                            className="mr-md"
                                            name="adminIntvPropStateGbsList"
                                            v-model="searchInput14.searchIntvPropStateGbs"
                                            :options="data_adminIntvStateGb"
                                        />
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>면접 가능일</dt>
                                    <dd class="text-box">
                                      <template v-for="group in searchStuIntvInYnGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput14.searchIntvInYn" :value="group.value" />
                                      </template>
                                    </dd>
                                </dl>
                                <dl v-show="searchInput14.searchIntvInYn === 'Y'">
                                  <dt></dt>
                                  <dd>
                                    <KSACheckBoxGroup
                                        ref="intvDaysListRef"
                                        className="mr-md"
                                        name="intvDaysList"
                                        v-model="searchInput14.searchIntvAbleDay"
                                        :options="ojfIntvDayList"
                                    />
                                  </dd>
                                </dl>
                                <dl>
                                    <dt>제안 보낸일</dt>
                                    <dd class="text-box">
                                        <div class="grid">
                                            <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput14.searchDurationType" :value="group.value" />
                                            </template>
                                            <div style="display: inline-block;" v-if="searchInput14.searchDurationType !== 'all'">
                                                <KSADatepickerTerms
                                                    :startDate="searchInput14.startYmd"
                                                    :endDate="searchInput14.endYmd"
                                                    @update:startDate="(value)=> searchInput14.startYmd = value"
                                                    @update:endDate="(value)=> searchInput14.endYmd = value"
                                                />
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                                <!-- name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명 검색 -->
                                <dl>
                                    <dt>
                                        <KSASelect ref="searchTypeRef" :options="searchTypeGroup14" class="select" @selectOption="onSelectSearchTypeGroup"/>
                                    </dt>
                                    <dd>
                                        <KSAInput class="text-box" v-model="searchInput14.searchInput" :placeholder="searchInputPlaceholder14" />
                                    </dd>
                                </dl>
                                <div class="btn-wrap">
                                    <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                                    <KSAPrimaryButton text="검색" @click="onClickSearch" />
                                </div>
                            </div>
                        </div>
                        <!-- e: 검색 -->
                        <!-- s: 버튼영역 -->
                        <div class="list-top" style="justify-content: space-between;">
                            <p>전체 <span>{{ totalCount }}</span>개</p>
                            <div>
                                <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                            </div>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                            <table class="horizontal" v-if="corpList14 !== null">
                                <tr>
                                    <th>NO</th>
                                    <th>회원코드</th>
                                    <th>이름</th>
                                    <th>아이디</th>
                                    <th>이력서 제목</th>
                                    <th>관심 카테고리</th>
                                    <th>면접 가능일</th>
                                    <th>면접제안 공고 제목</th>
                                    <th>기업명</th>
                                    <th>마스터</th>
                                    <th>제안일</th>
                                    <th>상태</th>
                                    <th>상태변경</th>
                                </tr>
                                <tr v-for="ojf in corpList14">
                                    <td>{{ ojf.boardNo }}</td>
                                    <td>{{ ojf.userCd }}</td>
                                    <td class="clickable blue">
                                        <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userCd}}">{{ ojf.userName }}</RouterLink>
                                    </td>
                                    <td>{{ ojf.userLoginId }}</td>
                                    <td class="text-overflow long-overflow">
                                      <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                        {{ resumeAttaches.fileName }}
                                      </span>
                                      <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                        {{ ojf.title }}
                                      </span>
                                    </td>
                                    <td>
                                      <span v-if="ojf.fileYn === 'Y'">-</span>
                                      <span v-else>{{ ojf.interests }}</span>
                                    </td>
                                    <td class="word-break-all">
                                        <span v-if="ojf.intvInYn === 'Y' && isAllSelected3">
                                          전체 일정 가능
                                          [{{ ojf.intvAbleDay }}]
                                        </span>
                                        <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                        <span v-else>면접 일정 조율</span>
                                    </td>
                                    <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                                    <td class="clickable blue">
                                      <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                                    </td>
                                     <td class="clickable blue">
                                      <RouterLink :to="{name:'MemberDetail', params:{id: ojf.masterUserId}}">{{ ojf.masterUserName }}</RouterLink>
                                    </td>
                                    <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                    <td>
                                      <span v-if="ojf.intvPropStateGb === '01'">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                                      <span v-else-if="ojf.intvPropStateGb === '02' || ojf.intvPropStateGb === '05'" class="blue">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                                      <span v-else-if="ojf.intvPropStateGb === '03' || ojf.intvPropStateGb === '06'" class="red">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                                      <span v-else class="gray">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                                    </td>
                                    <td>
                                      <div v-if="ojf.intvPropStateGb === '01'">
                                        <KSATextButton text="제안취소" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '04')" class="clickable black_button"></KSATextButton>
                                      </div>
                                      <div v-else-if="ojf.intvPropStateGb === '02'">
                                        <KSATextButton text="최종합격" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '05')" class="clickable black_button"></KSATextButton><br/>
                                        <KSATextButton text="최종불합격" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '06')" class="clickable black_button"></KSATextButton>
                                      </div>
                                      <div v-else-if="ojf.intvPropStateGb === '05'">
                                        <KSATextButton text="최종불합격" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '06')" class="clickable black_button"></KSATextButton>
                                      </div>
                                      <div v-else-if="ojf.intvPropStateGb === '06'">
                                        <KSATextButton text="최종합격" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '05')" class="clickable black_button"></KSATextButton>
                                      </div>
                                      <div v-else>-</div>
                                    </td>
                                </tr>
                                <tr v-if="corpList14.length === 0">
                                  <td colspan="13">면접 제안 내역이 없습니다.</td>
                                </tr>
                            </table>
                        </div>
                        <Paginate
                            v-if="corpList14.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                        />
                    </div>
                    <!-- e: tabIndex2 4 : 면접제안 인재 ----------------------------------------------------------------->

                </div>
                <!-- e: tabIndex 1 : 재직자/기업 ------------------------------------------------------------------->

        <!-- s: tabIndex 2 : 학생/취업준비생 ---------------------------------------------------------------->
        <div v-else-if="tabIndex === 2">
            <KSATab style="grid-template-columns: repeat(4, 1fr);" class="mb-lg"
                :options="[
                            {label: `참가회원${'(' + totalCnt21 + ')'}`, value: 1},
                            {label: `이력서${'(' + totalCnt22 + ')'}`, value: 2},
                            {label: `입사지원${'(' + totalCnt23 + ')'}`, value: 3},
                            {label: `받은 면접제안${'(' + totalCnt24 + ')'}`, value: 4},
                          ]"
                @change="onChangeTab2"
            />

            <!-- s: tabIndex2 1 : 참가회원 ----------------------------------------------------------------->
            <div v-if="tabIndex2 === 1">
                <!-- s: 검색 -->
                <div class="filter-wrap" :class="{'open': searchOpen}">
                    <p @click="searchOpen = !searchOpen">검색</p>
                    <div class="filter">
                        <!-- userName 이름, id 아이디, code 회원코드 검색 -->
                        <dl>
                            <dt>
                                <KSASelect ref="searchTypeRef" :options="searchTypeGroup21" class="select" @selectOption="onSelectSearchTypeGroup"/>
                            </dt>
                            <dd>
                                <KSAInput class="text-box" v-model="searchInput21.searchInput" :placeholder="searchInputPlaceholder21" />
                            </dd>
                        </dl>
                        <dl>
                            <dt>승인일<br/>(참가확정)</dt>
                            <dd class="text-box">
                                <div class="grid">
                                    <template v-for="group in searchApprovedDurationTypeGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput21.searchApprovedDurationType" :value="group.value" />
                                    </template>
                                    <div style="display: inline-block;" v-if="searchInput21.searchApprovedDurationType !== 'all'">
                                        <KSADatepickerTerms
                                            :startDate="searchInput21.startApprovedYmd"
                                            :endDate="searchInput21.endApprovedYmd"
                                            @update:startDate="(value)=> searchInput21.startApprovedYmd = value"
                                            @update:endDate="(value)=> searchInput21.endApprovedYmd = value"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <dl>
                            <dt>참가 신청일</dt>
                            <dd class="text-box">
                                <div class="grid">
                                    <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput21.searchDurationType" :value="group.value" />
                                    </template>
                                    <div style="display: inline-block;" v-if="searchInput21.searchDurationType !== 'all'">
                                        <KSADatepickerTerms
                                            :startDate="searchInput21.startYmd"
                                            :endDate="searchInput21.endYmd"
                                            @update:startDate="(value)=> searchInput21.startYmd = value"
                                            @update:endDate="(value)=> searchInput21.endYmd = value"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <div class="btn-wrap">
                            <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                            <KSAPrimaryButton text="검색" @click="onClickSearch" />
                      </div>
                    </div>
                </div>
                <!-- e: 검색 -->
                <!-- s: 버튼영역 -->
                <div class="list-top">
                  <div class="grid">
                    <KSAPrimaryButton v-if="tabIndex2 === 1" text="엑셀 다운로드" @click="onClickStuExcelDownload" />
                  </div>
                  <div>
                    <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                  </div>
                </div>
                <!-- e: 버튼영역 -->
                <div class="table-form">
                    <table class="horizontal" v-if="stuList21 !== null">
                        <tr>
                            <th>NO</th>
                            <th>참가 상태</th>
                            <th>회원코드</th>
                            <th>이름</th>
                            <th>아이디</th>
                            <th>승인일(참가확정)</th>
                            <th>참가 신청일</th>
                            <th>신청정보</th>
                            <th>신청 이력서</th>
                        </tr>
                        <tr v-for="ojf in stuList21">
                            <td>{{ ojf.boardNo }}</td>
                            <td>
                              <span :class="ojf.joinStateGb === '11' ? 'blue' : ojf.joinStateGb === '21' ? 'red' : ojf.joinStateGb === '03' || ojf.joinStateGb === '04' ? 'gray' : ''">{{ $gbNameKR("ADMIN_JOIN_STATE_GB", ojf.joinStateGb) }}</span>
                            </td>
                            <td>{{ ojf.userCd }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td>{{ ojf.userLoginId }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.joinStateModifyDate) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td class="clickable blue" @click="onClickRecruitmentHall(ojf.userId)">신청정보</td>
                            <td class="clickable blue" @click="onClickMyResume(ojf.resumeId)">신청 이력서</td>
                        </tr>
                    </table>
                    <div class="result-none" v-if="stuList21.length === 0">
                        참가 회원이 없습니다.
                    </div>
                </div>
                <Paginate
                    v-if="stuList21.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
            </div>
            <!-- e: tabIndex2 1 : 참가회원 ----------------------------------------------------------------->

            <!-- s: tabIndex2 2 : 이력서 ------------------------------------------------------------------>
            <div v-else-if="tabIndex2 === 2">
              <div v-show="viewMode === BASIC">
                <!-- s: 검색 -->
                <div class="filter-wrap" :class="{'open': searchOpen}">
                  <p @click="searchOpen = !searchOpen">검색</p>
                  <div class="filter">
                    <dl>
                      <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                      <dd>
                        <KSACheckBoxGroup
                            ref="interestsListRef"
                            className="mr-md"
                            name="interestsList"
                            v-model="searchInput22.searchInterests"
                            :options="data_interests"
                        />
                      </dd>
                    </dl>
                    <dl>
                      <dt>면접 가능일</dt>
                      <dd class="text-box">
                        <template v-for="group in searchStuIntvInYnGroup" key="item.value" >
                          <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput22.searchIntvInYn" :value="group.value" />
                        </template>
                      </dd>
                    </dl>
                    <dl v-show="searchInput22.searchIntvInYn === 'Y'">
                      <dt></dt>
                      <dd>
                        <KSACheckBoxGroup
                            ref="intvDaysListRef"
                            className="mr-md"
                            name="intvDaysList"
                            v-model="searchInput22.searchIntvAbleDay"
                            :options="ojfIntvDayList"
                        />
                      </dd>
                    </dl>
                    <dl>
                      <dt>등록일</dt>
                      <dd class="text-box">
                        <div class="grid">
                          <template v-for="group in searchDurationTypeGroup" key="item.value" >
                            <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput22.searchDurationType" :value="group.value" />
                          </template>
                          <div style="display: inline-block;" v-if="searchInput22.searchDurationType !== 'all'">
                            <KSADatepickerTerms
                                :startDate="searchInput22.startYmd"
                                :endDate="searchInput22.endYmd"
                                @update:startDate="(value)=> searchInput22.startYmd = value"
                                @update:endDate="(value)=> searchInput22.endYmd = value"
                            />
                          </div>
                        </div>
                      </dd>
                    </dl>
                    <!-- name 이름, id 아이디, rTitle 이력서 제목 검색 -->
                    <dl>
                      <dt>
                        <KSASelect ref="searchTypeRef" :options="searchTypeGroup22" class="select" @selectOption="onSelectSearchTypeGroup"/>
                      </dt>
                      <dd>
                        <KSAInput class="text-box" v-model="searchInput22.searchInput" :placeholder="searchInputPlaceholder22" />
                      </dd>
                    </dl>
                    <div class="btn-wrap">
                      <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                      <KSAPrimaryButton text="검색" @click="onClickSearch" />
                    </div>
                  </div>
                </div>
                <!-- e: 검색 -->
                <!-- s: 버튼영역 -->
                <div class="list-top" style="justify-content: flex-end;">
                  <div>
                    <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                  </div>
                </div>
                <!-- e: 버튼영역 -->
                <div class="table-form">
                  <table class="horizontal" v-if="stuList22 !== null">
                    <tr>
                      <th>NO</th>
                      <th>회원코드</th>
                      <th>이름</th>
                      <th>아이디</th>
                      <th>이력서 제목</th>
                      <th>관심 카테고리</th>
                      <th>면접 가능일</th>
                      <th>입사지원</th>
                      <th>최근 수정일</th>
                      <th>등록일</th>
                      <th>인재정보 공개</th>
                    </tr>
                    <tr v-for="ojf in stuList22">
                      <td>{{ ojf.boardNo }}</td>
                      <td>{{ ojf.userCd }}</td>
                      <td class="clickable blue">
                        <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                      </td>
                      <td>{{ ojf.userLoginId }}</td>
                      <td class="text-overflow long-overflow">
                        <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                          {{ resumeAttaches.fileName }}
                        </span>
                        <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                          {{ ojf.title }}
                        </span>
                      </td>
                      <td>
                        <span v-if="ojf.fileYn === 'Y'">-</span>
                        <span v-else>{{ ojf.interests }}</span>
                      </td>
                      <td class="word-break-all">
                        <span v-if="ojf.intvInYn === 'Y' && isAllSelected4">
                          전체 일정 가능
                          [{{ ojf.intvAbleDay }}]
                        </span>
                        <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                        <span v-else>면접 일정 조율</span>
                      </td>
                      <td class="clickable blue" @click="setViewMode(RETRIEVE_APPLICANT2, ojf.resumeId, ojf.fileYn)">{{ ojf.applicantCnt }}</td>
                      <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                      <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                      <td>
                        <span v-if="ojf.resOpenYn === 'Y'">
                          <img src="../../../../../assets/images/toggle_on.png" @click="onClickChangeResOpenYn(ojf.userId, ojf.resumeId, 'N')" style="cursor:pointer;" />
                        </span>
                        <span v-else>
                          <span v-if="ojf.fileYn === 'Y'">
                            -
                          </span>
                          <span v-else>
                            <img src="../../../../../assets/images/toggle_off.png" @click="onClickChangeResOpenYn(ojf.userId, ojf.resumeId, 'Y')" style="cursor:pointer;" />
                          </span>
                        </span>
                      </td>
                    </tr>
                  </table>
                  <div class="result-none" v-if="stuList22.length === 0">
                    등록된 이력서가 없습니다.
                  </div>
                </div>
                <Paginate
                    v-if="stuList22.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>

                      <!-- s: tabIndex2 2 : 이력서 - 입사지원 상세 -------------------------------------------------->
                      <div v-show="viewMode !== BASIC">
                        <div v-if="viewMode === RETRIEVE_APPLICANT2">
                          <KSASecondaryButton text="이전" @click="setViewMode(BASIC)" />
                          <div class="list-top">
                            <p>총 <span>{{ $number(totalCount)}}</span>명</p>
                            <div v-if="detailCommonData !== 'Y'">
                              <KSAPrimaryButton text="이력서 보기" @click="onClickMyResume(detailCommonId)" />
                            </div>
                          </div>
                          <div class="table-form">
                            <table class="horizontal">
                              <tr>
                                <th>NO</th>
                                <th>기업명</th>
                                <th>마스터</th>
                                <th>채용공고 제목</th>
                                <th>관심 카테고리</th>
                                <th>면접 가능일</th>
                                <th>면접 방식</th>
                                <th>입사 지원일</th>
                                <th>상태</th>
                                <th>상태변경</th>
                              </tr>
                              <tr v-for="ojf in applicantList2">
                                <td>{{ ojf.boardNo }}</td>
                                <td class="clickable blue">
                                  <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                                </td>
                                <td class="clickable blue">
                                  <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                                </td>
                                <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                                <td>{{ ojf.interests }}</td>
                                <td class="word-break-all">
                                  <span v-if="ojf.intvInYn === 'Y' && isAllSelected5">
                                    전체 일정 가능
                                    [{{ ojf.intvAbleDay }}]
                                  </span>
                                  <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                  <span v-else>면접 일정 조율</span>
                                </td>
                                <td>{{ $gbNameKR('INTV_GB', ojf.intvGb) }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                <td>
                                  <span v-if="ojf.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                  <span v-else-if="ojf.applyStateGb === '03' || ojf.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                  <span v-else-if="ojf.applyStateGb === '04' || ojf.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                  <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                </td>
                                <td>
                                  <div v-if="ojf.applyStateGb === '01'">
                                    <KSATextButton class="clickable black_button" text="지원취소" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '02')"/>
                                  </div>
                                  <div v-else>
                                    -
                                  </div>
                                </td>
                              </tr>
                            </table>
                            <div class="result-none" v-if="applicantList2.length === 0">
                              입사지원 내역이 없습니다.
                            </div>
                          </div>
                          <Paginate
                              v-if="applicantList2.length > 0"
                              v-model="currentPage"
                              :page-count="totalPages"
                              :click-handler="onSelectPage"
                          />
                        </div>
                      </div>
                      <!-- e: tabIndex2 2 : 이력서 - 입사지원 상세--------------------------------------------------->
                    </div>
                    <!-- e: tabIndex2 2 : 이력서 ------------------------------------------------------------------>

                    <!-- s: tabIndex2 3 : 입사지원 ---------------------------------------------------------------->
                    <div v-else-if="tabIndex2 === 3">
                        <!-- s: 검색 -->
                        <div class="filter-wrap" :class="{'open': searchOpen}">
                            <p @click="searchOpen = !searchOpen">검색</p>
                            <div class="filter">
                                <dl>
                                    <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                    <dd>
                                        <KSACheckBoxGroup
                                            ref="interestsListRef"
                                            className="mr-md"
                                            name="interestsList"
                                            v-model="searchInput23.searchInterests"
                                            :options="data_interests"
                                        />
                                    </dd>
                                </dl>
                                <dl>
                                    <dt style="display:block;">상태</dt>
                                    <dd>
                                        <KSACheckBoxGroup
                                            ref="applyStateGbsListRef"
                                            className="mr-md"
                                            name="applyStateGbsList"
                                            v-model="searchInput23.searchApplyStateGbs"
                                            :options="data_applyStateGb"
                                        />
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>면접 가능일</dt>
                                    <dd class="text-box">
                                      <template v-for="group in searchStuIntvInYnGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput23.searchIntvInYn" :value="group.value" />
                                      </template>
                                    </dd>
                                </dl>
                                <dl v-show="searchInput23.searchIntvInYn === 'Y'">
                                    <dt></dt>
                                    <dd>
                                      <KSACheckBoxGroup
                                          ref="intvDaysListRef"
                                          className="mr-md"
                                          name="intvDaysList"
                                          v-model="searchInput23.searchIntvAbleDay"
                                          :options="ojfIntvDayList"
                                      />
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>입사지원일</dt>
                                    <dd class="text-box">
                                        <div class="grid">
                                            <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput23.searchDurationType" :value="group.value" />
                                            </template>
                                            <div style="display: inline-block;" v-if="searchInput23.searchDurationType !== 'all'">
                                                <KSADatepickerTerms
                                                    :startDate="searchInput23.startYmd"
                                                    :endDate="searchInput23.endYmd"
                                                    @update:startDate="(value)=> searchInput23.startYmd = value"
                                                    @update:endDate="(value)=> searchInput23.endYmd = value"
                                                />
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                                <!-- applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목 검색 -->
                                <dl>
                                    <dt>
                                        <KSASelect ref="searchTypeRef" :options="searchTypeGroup23" class="select" @selectOption="onSelectSearchTypeGroup"/>
                                    </dt>
                                    <dd>
                                        <KSAInput class="text-box" v-model="searchInput23.searchInput" :placeholder="searchInputPlaceholder23" />
                                    </dd>
                                </dl>
                                <div class="btn-wrap">
                                    <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                                    <KSAPrimaryButton text="검색" @click="onClickSearch" />
                                </div>
                            </div>
                        </div>
                        <!-- e: 검색 -->
                        <!-- s: 버튼영역 -->
                        <div class="list-top" style="justify-content: flex-end;">
                            <div>
                                <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                            </div>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                            <table class="horizontal" v-if="stuList23 !== null">
                                <tr>
                                    <th>NO</th>
                                    <th>기업명</th>
                                    <th>마스터</th>
                                    <th>채용공고 제목</th>
                                    <th>관심 카테고리</th>
                                    <th>면접 가능일</th>
                                    <th>면접 방식</th>
                                    <th>이력서 제목</th>
                                    <th>이름</th>
                                    <th>입사 지원일</th>
                                    <th>상태</th>
                                    <th>상태변경</th>
                                </tr>
                                <tr v-for="ojf in stuList23">
                                    <td>{{ ojf.boardNo }}</td>
                                    <td class="clickable blue">
                                      <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                                    </td>
                                    <td class="clickable blue">
                                        <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                                    </td>
                                    <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                                    <td>{{ ojf.interests }}</td>
                                    <td class="word-break-all">
                                        <span v-if="ojf.intvInYn === 'Y' && isAllSelected6">
                                          전체 일정 조율
                                          [{{ ojf.intvAbleDay }}]
                                        </span>
                                        <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                        <span v-else>면접 일정 조율</span>
                                    </td>
                                    <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                                    <td class="text-overflow long-overflow">
                                      <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                        {{ resumeAttaches.fileName }}
                                      </span>
                                      <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                        {{ ojf.title }}
                                      </span>
                                    </td>
                                    <td class="clickable blue">
                                        <RouterLink :to="{name:'MemberDetail', params:{id: ojf.applicantId}}">{{ ojf.applicantName }}</RouterLink>
                                    </td>
                                    <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                    <td>
                                      <span v-if="ojf.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                      <span v-else-if="ojf.applyStateGb === '03' || ojf.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                      <span v-else-if="ojf.applyStateGb === '04' || ojf.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                      <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                    </td>
                                    <td>
                                      <div v-if="ojf.applyStateGb === '01'">
                                        <KSATextButton class="clickable black_button" text="지원취소" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '02')"/>
                                      </div>
                                      <div v-else>
                                        -
                                      </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="result-none" v-if="stuList23.length === 0">
                                입사지원 내역이 없습니다.
                            </div>
                        </div>
                        <Paginate
                            v-if="stuList23.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                        />
                    </div>
                    <!-- e: tabIndex2 3 : 입사지원 ---------------------------------------------------------------->

                    <!-- s: tabIndex2 4 : 받은 면접제안 ------------------------------------------------------------>
                    <div v-else-if="tabIndex2 === 4">
                      <!-- s: 검색 -->
                      <div class="filter-wrap" :class="{'open': searchOpen}">
                        <p @click="searchOpen = !searchOpen">검색</p>
                        <div class="filter">
                          <dl>
                            <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                            <dd>
                              <KSACheckBoxGroup
                                  ref="interestsListRef"
                                  className="mr-md"
                                  name="interestsList"
                                  v-model="searchInput24.searchInterests"
                                  :options="data_interests"
                              />
                            </dd>
                          </dl>
                          <dl>
                            <dt style="display:block;">상태</dt>
                            <dd>
                              <KSACheckBoxGroup
                                  ref="intvPropStateGbsListRef"
                                  className="mr-md"
                                  name="intvPropStateGbsList"
                                  v-model="searchInput24.searchIntvPropStateGbs"
                                  :options="data_userIntvStateGb"
                              />
                            </dd>
                          </dl>
                          <dl>
                            <dt>면접 가능일</dt>
                            <dd class="text-box">
                              <template v-for="group in searchStuIntvInYnGroup" key="item.value" >
                                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput24.searchIntvInYn" :value="group.value" />
                              </template>
                            </dd>
                          </dl>
                          <dl v-show="searchInput24.searchIntvInYn === 'Y'">
                            <dt></dt>
                            <dd>
                              <KSACheckBoxGroup
                                  ref="intvDaysListRef"
                                  className="mr-md"
                                  name="intvDaysList"
                                  v-model="searchInput24.searchIntvAbleDay"
                                  :options="ojfIntvDayList"
                              />
                            </dd>
                          </dl>
                          <dl>
                            <dt>제안 받은일</dt>
                            <dd class="text-box">
                              <div class="grid">
                                <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                  <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput24.searchDurationType" :value="group.value" />
                                </template>
                                <div style="display: inline-block;" v-if="searchInput24.searchDurationType !== 'all'">
                                  <KSADatepickerTerms
                                      :startDate="searchInput24.startYmd"
                                      :endDate="searchInput24.endYmd"
                                      @update:startDate="(value)=> searchInput24.startYmd = value"
                                      @update:endDate="(value)=> searchInput24.endYmd = value"
                                  />
                                </div>
                              </div>
                            </dd>
                          </dl>
                          <!-- applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목 검색 -->
                          <dl>
                            <dt>
                              <KSASelect ref="searchTypeRef" :options="searchTypeGroup24" class="select" @selectOption="onSelectSearchTypeGroup"/>
                            </dt>
                            <dd>
                              <KSAInput class="text-box" v-model="searchInput24.searchInput" :placeholder="searchInputPlaceholder24" />
                            </dd>
                          </dl>
                          <div class="btn-wrap">
                            <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                            <KSAPrimaryButton text="검색" @click="onClickSearch" />
                          </div>
                        </div>
                      </div>
                      <!-- e: 검색 -->
                      <!-- s: 버튼영역 -->
                      <div class="list-top" style="justify-content: flex-end;">
                        <div>
                          <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                        </div>
                      </div>
                      <!-- e: 버튼영역 -->
                      <div class="table-form">
                        <table class="horizontal" v-if="stuList24 !== null">
                          <tr>
                            <th>NO</th>
                            <th>기업명</th>
                            <th>마스터</th>
                            <th>채용공고 제목</th>
                            <th>관심 카테고리</th>
                            <th>면접 가능일</th>
                            <th>면접 방식</th>
                            <th>이력서 제목</th>
                            <th>이름</th>
                            <th>제안 받은일</th>
                            <th>상태</th>
                            <th>상태변경</th>
                          </tr>
                          <tr v-for="ojf in stuList24">
                            <td>{{ ojf.boardNo }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                            </td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                            <td>{{ ojf.interests }}</td>
                            <td class="word-break-all">
                              <span v-if="ojf.intvInYn === 'Y' && isAllSelected7">
                                전체 일정 가능
                                [{{ ojf.intvAbleDay }}]
                              </span>
                              <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                              <span v-else>면접 일정 조율</span>
                            </td>
                            <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                            <td class="text-overflow long-overflow">
                              <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                {{ resumeAttaches.fileName }}
                              </span>
                              <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                {{ ojf.title }}
                              </span>
                            </td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.applicantId}}">{{ ojf.applicantName }}</RouterLink>
                            </td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td>
                              <span v-if="ojf.intvPropStateGb === '01'">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                              <span v-else-if="ojf.intvPropStateGb === '02' || ojf.intvPropStateGb === '05'" class="blue">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                              <span v-else-if="ojf.intvPropStateGb === '03' || ojf.intvPropStateGb === '06'" class="red">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                              <span v-else class="gray">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                            </td>
                            <td>
                              <div v-if="ojf.intvPropStateGb === '01'">
                                <KSATextButton text="제안수락" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '02')" class="clickable black_button"></KSATextButton><br/>
                                <KSATextButton text="제안거절" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '03')" class="clickable black_button"></KSATextButton>
                              </div>
                              <div v-else-if="ojf.intvPropStateGb === '02'">
                                <KSATextButton text="제안거절" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '03')" class="clickable black_button"></KSATextButton>
                              </div>
                              <div v-else-if="ojf.intvPropStateGb === '03'">
                                <KSATextButton text="제안수락" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '02')" class="clickable black_button"></KSATextButton>
                              </div>
                              <div v-else>-</div>
                            </td>
                          </tr>
                        </table>
                        <div class="result-none" v-if="stuList24.length === 0">
                          받은 면접제안 내역이 없습니다.
                        </div>
                      </div>
                      <Paginate
                          v-if="stuList24.length > 0"
                          v-model="currentPage"
                          :page-count="totalPages"
                          :click-handler="onSelectPage"
                      />
                    </div>
                    <!-- e: tabIndex2 4 : 받은 면접제안 ------------------------------------------------------------>

        </div>
        <!-- e: tabIndex 1 : 학생/취업준비생 --------------------------------------------------------------->

    </div>
    <JobFairJobNoticeModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
    <JobFairResumeModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
    <RecruitmentHallCorpModal ref="recruitmentHallCorpModal" /> <!-- 신청정보 보기 - 기업 -->
    <RecruitmentHallModal ref="recruitmentHallModal" /> <!-- 신청정보 보기 - 구직자 -->
    <JobFairResumeOpenModal ref="jobFairResumeOpenModal" :showButtons="false"/> <!-- 텍스트 색상을 위한 디자인 팝업 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.blue {
  color: $blue_color;
}
.red {
  color: $red_color;
}
.gray {
  color: $gray_color;
}
.textarea-box {
    height: 100px;
}
.clickable {
  text-decoration: underline;
  cursor: pointer;
}
.file {
  color: $blue_color;
  cursor: pointer;
}

.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          span {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>